/* eslint-disable @typescript-eslint/ban-ts-comment */
import { SearchInRange } from "Pages/Project/Documents/Stores/DocumentsSearchStore";

/**
 * Converts radio button value to post object fields.
 * Works together with radioButtonValueToSearchPostObject.ts
 */
export function radioButtonValueToSearchPostObject(
  postObject: API_DocSearchReq,
  radioValue: SearchInRange,
  radioVirusValue: "problematicWithZeroSize" | "problematicWithMalware" = null
) {
  if (!postObject.folderId) {
    console.warn('c% "folderId" should always be specified!', "color: black; background: yellow; font-weight: bold;");
  }
  if (radioValue === "CURR_CHILDREN") {
    postObject.includeSubDirectories = true;
  } else if (radioValue === "ALL") {
    postObject.folderId = null;
    postObject.includeSubDirectories = null;
  }
  if (radioVirusValue === "problematicWithZeroSize") {
    // @ts-ignore
    postObject.problematicWithZeroSize = true;
    postObject.problematicWithMalware = false;
  } else if (radioVirusValue === "problematicWithMalware") {
    // @ts-ignore
    postObject.problematicWithMalware = true;
    postObject.problematicWithZeroSize = false;
  }
  return postObject;
}
